export default __webpack_public_path__ + "static/world-map-855099d28046d5fde5f1edb3b723bb37.webp";